import { Link } from "react-router-dom";
import { getLocalStorage } from "../../../helpers/storage";

const Banner = () => {
  const fireNumber = parseInt(getLocalStorage("fire_number") || "0") ?? 0;

  const gridOverlayStyle = {
    background:
      "linear-gradient(245.74deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0) 45.88%)",
  };

  const renderTabContent = () => {
    if (fireNumber === 0) {
      return (
        <div className="flex flex-col items-start">
          <h1 className="text-[30px] font-medium text-white leading-tight mt-6">
            Calculate your
          </h1>
          <p
            className="text-[60px] font-medium tracking-wide italic -mt-4"
            style={{
              color: "transparent",
              WebkitTextStroke: "1px #D4B86A",
            }}
          >
            FIRE
          </p>
        </div>
      );
    } else {
      return (
        <div className="flex flex-col items-start">
          <div className="flex items-baseline gap-2">
            <p
              className="text-[40px] font-medium tracking-wide italic"
              style={{
                color: "transparent",
                WebkitTextStroke: "1px #D4B86A",
              }}
            >
              FIRE
            </p>
            <span className="text-[30px] font-medium text-white ">number</span>
          </div>
          <p className="text-[50px] font-bold leading-none bg-gradient-text text-transparent bg-clip-text mb-2">
            {fireNumber >= 10000000
              ? `${(fireNumber / 10000000).toFixed(2)} Cr`
              : fireNumber >= 100000
                ? `${(fireNumber / 100000).toFixed(2)} L`
                : fireNumber >= 1000
                  ? `${(fireNumber / 1000).toFixed(2)} k`
                  : `${fireNumber.toFixed(2)}`}
          </p>
        </div>
      );
    }
  };

  return (
    <Link to="/fire-calculator">
      <div className="">
        <div
          className={`relative bg-black rounded-xl overflow-hidden h-[140px]`}
        >
          <img
            src="/assets/fire-calculator/overlay.png"
            alt="FIRE Icon"
            className="absolute inset-0 object-contain"
          />
          {/* Grid Overlay */}
          <div className="absolute inset-0" style={gridOverlayStyle} />

          <div className="relative h-full flex items-center justify-between pl-12 pr-8">
            {renderTabContent()}
            <img
              src="/assets/fire-calculator/banner-element.png"
              alt="FIRE Icon"
              className="h-[140px] object-contain"
            />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Banner;
